const firebaseConfig = (window as any).APP_CONFIG.firebaseConfig;
declare const firebase: any;

export const generateFirebaseToken = (getIdToken: (token: string) => void) => {
  Notification.requestPermission().then((permission) => {
    if (permission === "granted") {
      // Initialize Firebase app using global firebase object
      const app = firebase.initializeApp({
        apiKey: firebaseConfig.apiKey,
        authDomain: firebaseConfig.authDomain,
        projectId: firebaseConfig.projectId,
        storageBucket: firebaseConfig.storageBucket,
        messagingSenderId: firebaseConfig.messagingSenderId,
        appId: firebaseConfig.appId,
        measurementId: firebaseConfig.messurementId, // typo? maybe measurementId
      });

      // Get messaging instance
      const messaging = firebase.messaging();

      // Request FCM token
      messaging
        .getToken({ vapidKey: firebaseConfig.vapidKey })
        .then((currentToken: string | null) => {
          if (currentToken) {
            getIdToken(currentToken);
          } else {
            console.log("Cannot get token");
          }
        })
        .catch((err: any) => {
          console.log("An error occurred while retrieving token.", err);
        });

      // Handle incoming messages
      messaging.onMessage((payload: any) => {
        console.log("Message received.", payload);
        const title = payload.notification?.title || "HrnSoft";
        const body = payload.notification?.body;
        const notificationOptions = {
          body: body,
          icon: payload.notification?.icon || "default",
        };
        new Notification(title, notificationOptions);
      });
    } else {
      console.log("Do not have permission!");
    }
  });
};
